<!-- SPDX-License-Identifier: GPL-3.0-or-later -->
<script lang="ts">
  import type { PeerInfo } from '@ffb/shared';
  import ParticipantCard from './ParticipantCard.svelte';

  interface Props {
    me: { name: string; audioLevel: number; muted: boolean };
    peers: Record<string, PeerInfo>;
  }

  let { me, peers }: Props = $props();

  const peerEntries = $derived(Object.entries(peers));
</script>

<div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
  <ParticipantCard name={me.name} isMe audioLevel={me.audioLevel} muted={me.muted} connected />
  {#each peerEntries as [id, peer] (id)}
    <ParticipantCard
      name={peer.name || '...'}
      audioLevel={peer.audioLevel ?? 0}
      muted={peer.muted ?? false}
      connected={peer.connected}
    />
  {/each}
</div>
